import React from 'react';
import { IconBase } from '../Base';
export const IconPEN = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M24 12C24 6.84046 20.7435 2.4419 16.1739 0.746429V23.2537C20.7435 21.5581 24 17.1596 24 12Z", fill: "#D80027" }),
    React.createElement("path", { d: "M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2536V0.746429C3.2565 2.4419 0 6.84046 0 12Z", fill: "#D80027" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_8752" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=PEN.js.map